/**
 * AdminShell — Süperadmin panel shell.
 *
 * Merchant AppShell'in BİREBİR aynı yapısı (Sidebar + Topbar + max-w-1400px
 * ortalanmış main) ama `data-admin-scope` wrapper'ı ile `--primary` ve
 * `--brand-accent` CSS değişkenleri siyaha boyanır. Bu sayede paylaşılan
 * tüm bileşenler (Button, Switch, Toggle, Chip, Progress…) merchant'ta
 * mavi olurken admin'de otomatik siyah hale gelir.
 *
 * Auth guard: `useAdminAuth()`. Admin yoksa `/sayz-super-admin` login'e
 * yönlenir. Loading sırasında spinner.
 */
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAdminAuth } from "@/lib/admin-auth";
import AdminSidebar from "@/components/layout/AdminSidebar";
import AdminTopbar from "@/components/layout/AdminTopbar";
import { ADMIN_LOGIN_PATH, ADMIN_CHANGE_PW_PATH } from "@/lib/admin-path";

export default function AdminShell() {
    const { admin } = useAdminAuth();
    const loc = useLocation();

    if (admin === null) {
        return (
            <div className="min-h-screen grid place-items-center bg-background" data-testid="admin-loading">
                <div className="h-8 w-8 rounded-full border-2 border-border border-t-foreground animate-spin" />
            </div>
        );
    }
    if (admin === false) {
        return <Navigate to={ADMIN_LOGIN_PATH} replace state={{ from: loc.pathname }} />;
    }
    // İlk-giriş parola değiştirme zorunlu — her korumalı sayfadan önce bu
    // guard devreye girer. Change-password sayfasının kendi route'u aynı
    // path prefix altında olduğu için bu check sadece diğer path'leri
    // yönlendirir (yoksa döngü oluşurdu).
    if (admin.password_must_change && loc.pathname !== ADMIN_CHANGE_PW_PATH) {
        return <Navigate to={ADMIN_CHANGE_PW_PATH} replace />;
    }

    return (
        <div
            data-admin-scope=""
            data-testid="admin-shell"
            className="min-h-screen flex bg-background text-foreground"
        >
            <AdminSidebar />
            <div className="flex-1 min-w-0 flex flex-col">
                <AdminTopbar />
                <main className="flex-1 px-5 md:px-8 py-6 md:py-8 max-w-[1400px] w-full mx-auto animate-fade-in">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
